<template>
  <div class="bg-white shadow overflow-hidden sm:rounded-lg">
    <div class="px-4 py-5 sm:px-6">
      <h3 class="text-lg leading-6 font-medium text-gray-900">{{data.header.title}}</h3>
      <p class="mt-1 max-w-2xl text-sm text-gray-500">{{data.header.text}}</p>
      <p v-if="data.header.textTwo" class="mt-1 max-w-2xl text-sm font-bold text-red-500">{{data.header.textTwo}}</p>
    </div>
    <div class="border-t border-b border-gray-200">
      <dl>
        <div :class="{'bg-gray-50': key % 2 === 0, 'bg-white': key % 2 !== 0 }"
             class="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
             v-for="(item, key) in items" v-bind:key="key">
          <dt class="font-medium text-gray-500">{{item.label}}</dt>
          <dd class="mt-1 text-gray-900 sm:mt-0 sm:col-span-2">
            <slot v-if="item.value != null" v-bind:props="item"><span>{{item.value}}</span></slot>
            <span v-else class="text-gray-400 italic text-sm">{{$t('global.not_set')}}</span>
          </dd>
        </div>
      </dl>
    </div>
    <div class="px-4 py-5">
      <Link class="btn-indigo inline-flex items-center lg:mb-0 max-w-md" :href="data.updateLink">
        <span>{{$t('global.update')}}</span>
      </Link>
    </div>
  </div>
</template>
<script>
import {Link} from '@inertiajs/inertia-vue3'
import remove from 'lodash/remove'

export default{
  components: { Link },
  props: {
    data: {
      type: Object,
      required: true,
      default(){
        return {
          items: [{
            key: null,
            label: '',
            value: '',
            hide: false,
          }],
          updateLink: '',
          header: {
            title: '',
            text: ''
          }
        }
      }
    },
  },
  computed: {
    items() {
      remove(this.data.items, {
        hide: true
      })
      return this.data.items
    }
  }
}
</script>
